import { IEnumModel } from './../../../models/enum.model';
import { OsaExecucaoModalVisualizarRespostaComponent } from './modal-visualizar-resposta/osa-execucao-modal-visualizar-resposta.component';
import { OsaExecucaoIncluirSolicitacaoComponent } from './modal-incluir-solicitacao/osa-execucao-modal-incluir-solicitacao.component';
import { SolicitacaoTecnicaService } from "./../../../services/solicitacao-tecnica.service";
import { ISolicitacaoTecnicaModel } from "./../../../models/solicitacao-tecnica.model";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import Swal from "sweetalert2";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './../../../services/auth.service';
import { EnumRecursoPerfil } from './../../../models/enum/recurso-perfil.enum';
import { EnumAcaoRecurso } from './../../../models/enum/acao-recurso.enum';
import { OsaExecucaoModalAvaliarProrrogacaoComponent } from './modal-avaliar-prorrogacao/osa-execucao-modal-avaliar-prorrogacao.component';
import { IPlanejamentoModel } from '../../../models/planejamento.model';
import { PlanejamentoService } from "./../../../services/planejamento.service";
import { OsaExecucaoModalResponderSolicitacaoComponent } from './modal-responder-solicitacao/osa-execucao-modal-responder-solicitacao.component';
import {
	ModalJustificativaComponent
} from "../../../shared/components/modal-justificativa/modal-justificativa.component";
import { SharedService } from "../../../services/shared.service";
import { filter, take } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
	selector: "app-osa-execucao-aba-solicitacao-tecnica",
	templateUrl: "./osa-execucao-aba-solicitacao-tecnica.component.html",
	styleUrls: ["./osa-execucao-aba-solicitacao-tecnica.component.scss"],
})
export class OsaExecucaoAbaSolicitacaoTecnicaComponent implements OnInit {
	public displayedColumns: string[] = [
		"selecao",
		"numero",
		"assunto",
		"prazo",
		"tipo",
		"ug",
		"responsavel",
		"status",
		"resposta",
	];
	public dataSource = new MatTableDataSource<ISolicitacaoTecnicaModel>([]);
	public semDados = true;
	public selectedModel: ISolicitacaoTecnicaModel;
	public permitido: boolean = false;
	public dataVencida: boolean;
	public tipotrabalhoId: number;
	@Input() numeroOpa: string;
	@Input() numeroOsa: string;
	public tipoTrabalho: IEnumModel = {} as IEnumModel;
	@Input() visualizar: boolean;
	planejamentoId: number;
	public podePlanejar: boolean = false;
	public podeCancelarSolicitacao: boolean = false;
	public podeCancelarItem: boolean = false;
	public podeRespSolExterna: boolean = false;
	public podeApreciarProrrogacao: boolean = false;
	public podeHabilitarResposta: boolean = false;
	public podeAvaliarResposta: boolean = false;
	public podeImprimir: boolean = false;
	dataAtual = new Date();
	public planejamento: IPlanejamentoModel;

	constructor(
		private solicitacaoTecnicaService: SolicitacaoTecnicaService,
		private planejamentoService: PlanejamentoService,
		private matDialog: MatDialog,
		public router: Router,
		public route: ActivatedRoute,
		public authService: AuthService,
		private sharedService: SharedService
	) {
		this.tipotrabalhoId = +this.route.snapshot.paramMap.get("id");
		if (this.router.url.includes("planejamento")) {
			this.tipoTrabalho.nome = 'planejamento';
			this.tipoTrabalho.codigo = 7;
		}
		if (this.router.url.includes("osa")) {
			this.tipoTrabalho.nome = 'osa';
			this.tipoTrabalho.codigo = 4;
		}
		if (this.router.url.includes("osa-execucao")) {
			this.tipoTrabalho.nome = 'execucao';
			this.tipoTrabalho.codigo = 14;
		}
	}

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	private planejamentoIdSubscription: Subscription;
	private numeroOsaSubscription: Subscription;


	ngOnInit(): void {
		this.setarPermissoes();
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;

		this.planejamentoIdSubscription = this.sharedService.planejamentoId
			.pipe(
				filter(id => id !== null && id !== undefined),
				take(1)
			)
			.subscribe(id => {
				this.planejamentoId = id;
				this.obter();
			});
	}

	private setarPermissoes(): void {
		this.podePlanejar = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Executar);
		this.podeImprimir = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.Imprimir);
	}

	public obter() {
		this.solicitacaoTecnicaService
			.obter(this.tipotrabalhoId, this.tipoTrabalho?.nome)
			.then((res) => {


				if (res.dados) {
					this.dataSource = new MatTableDataSource<ISolicitacaoTecnicaModel>(res.dados);

					this.semDados = this.dataSource.filteredData.length === 0;
					this.dataSource.paginator = this.paginator;
					this.dataSource.sort = this.sort;
					this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
					this.selectedModel = null
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}

	public obterPlanejamento() {
		this.planejamentoService
			.obterPorId(this.tipotrabalhoId)
			.then((pla) => {
				this.planejamento = pla.dados;
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}

	private formatarDocumentoAssociado(numeroOsa: string): string {
		return numeroOsa ? `OSA ${numeroOsa}` : '';
	}


	public selecionar(item: any) {

		this.selectedModel =
			!this.selectedModel || this.selectedModel.id !== item.id
				? item
				: null;

		if (this.selectedModel?.status?.codigo === 1 || this.selectedModel?.status?.codigo === 2) {
			this.permitido = true;
		} else {
			this.permitido = false;
		}

		if (new Date(this.selectedModel?.prazo) < new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate())) {
			this.dataVencida = true;
		}

		this.podeCancelarSolicitacao = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
		this.podeCancelarItem = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
		this.podeRespSolExterna = (this.podePlanejar) && (this.selectedModel?.tipo == 2) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 6 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
		this.podeApreciarProrrogacao = (this.podePlanejar) && (this.selectedModel?.status.codigo == 5);
		this.podeHabilitarResposta = (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8) && (this.dataVencida);
		this.podeAvaliarResposta = (this.podePlanejar) && (this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8);
	}

	public imprimir(element: ISolicitacaoTecnicaModel) {
		this.router.navigateByUrl(`${this.tipoTrabalho}/${this.tipotrabalhoId}/solicitacao-tecnica-execucao/${element?.id}/imprimir`)
	}

	public sortingDataAccessor = (item, property) => {
		switch (property) {
			case "prazo":
				return item?.prazo;
			case "status":
				return item?.status?.descricao;
			case "ug":
				return item?.internaUnidadeGestora?.sigla;
			case "assunto":
				return item?.assunto;
			case "responsavel":
				return item?.internaResponsavel?.nome;
			default:
				return item[property];
		}
	};

	public incluirSolicitacaoTecnica(titulo: string, visualizar?: boolean, selectedModel?: ISolicitacaoTecnicaModel): void {
		// Pega o valor do numeroOsa do shared service
		this.sharedService.numeroOsa
			.pipe(
				filter(numero => numero !== null && numero !== undefined),
				take(1)
			)
			.subscribe(numeroOsa => {
				const dataFimRealizacao = this.sharedService.getDataFimRealizacao();
				const dialogConfig = new MatDialogConfig();
				dialogConfig.id = 'modal-component-solicitacao-tecnica-execucao';
				dialogConfig.width = '80%';
				dialogConfig.height = '90%';
				dialogConfig.hasBackdrop = true;
				dialogConfig.disableClose = true;
				dialogConfig.data = {
					titulo,
					element: selectedModel,
					id: selectedModel?.id,
					status: selectedModel?.status,
					visualizar,
					acaoCancelarItem: false,
					tipoTrabalhoId: this.tipotrabalhoId,
					planejamentoId: this.planejamentoId,
					documentoAssociado: this.formatarDocumentoAssociado(numeroOsa),
					tipoTrabalho: this.tipoTrabalho,
					numeroST: selectedModel?.numero,
					dataLimite: dataFimRealizacao
						? new Date(dataFimRealizacao)
						: new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
				};

				const modal = this.matDialog.open(
					OsaExecucaoIncluirSolicitacaoComponent,
					dialogConfig
				);

				modal.afterClosed().subscribe((data) => {
					if (data) {
					}
					this.obter();
				});

			});
	}

	public modalVisualizarResposta(id: number): void {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component-resposta';
		dialogConfig.width = '60%';
		dialogConfig.height = 'auto';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
			titulo: 'Visualizar Resposta',
			id: id,
		};

		const modal = this.matDialog.open(
			OsaExecucaoModalVisualizarRespostaComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data) {
			}
		});
	}

	public cancelarSolicitacao(id: number) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '45vw';
		dialogConfig.maxHeight = '85vh';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
		}
		const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
		modal.afterClosed().subscribe(justificativa => {
			if (justificativa) {

				const responsavelId = this.authService.usuario.id;

				this.solicitacaoTecnicaService.cancelarSolicitacao(id, justificativa, responsavelId)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					}).catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							icon: "error",
							text: err.mensagem.descricao,
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.obter()
					});
			}
		});
	}

	public excluir(id: number) {
		Swal.fire({
			title: "Excluir Registro",
			text: "Tem certeza que deseja excluir esse Registro?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim",
			cancelButtonText: "Não",
		}).then((res) => {
			if (res.value) {
				this.solicitacaoTecnicaService
					.excluir(id)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					})
					.catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							text: err.mensagem.descricao,
							icon: "error",
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.obter()
					}
					);
			}
		});
	}


	//#region botao Preencimento

	public cancelarItem(selectedModel?: ISolicitacaoTecnicaModel): void {
		this.sharedService.numeroOsa
			.pipe(
				filter(numero => numero !== null && numero !== undefined),
				take(1)
			)
			.subscribe(numeroOsa => {
				const dataFimRealizacao = this.sharedService.getDataFimRealizacao();
				const dialogConfig = new MatDialogConfig();
				dialogConfig.id = 'modal-component-solicitacao-tecnica';
				dialogConfig.width = '80%';
				dialogConfig.height = '90%';
				dialogConfig.hasBackdrop = true;
				dialogConfig.disableClose = true;
				dialogConfig.data = {
					titulo: "Cancelar Item da",
					element: selectedModel,
					id: selectedModel?.id,
					status: selectedModel?.status,
					visualizar: true,
					acaoCancelarItem: true,
					tipoTrabalhoId: this.tipotrabalhoId,
					planejamentoId: this.planejamentoId,
					documentoAssociado: this.formatarDocumentoAssociado(numeroOsa),
					tipoTrabalho: this.tipoTrabalho,
					numeroST: selectedModel?.numero,
					dataLimite: dataFimRealizacao
						? new Date(dataFimRealizacao)
						: new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
				};

				const modal = this.matDialog.open(
					OsaExecucaoIncluirSolicitacaoComponent,
					dialogConfig
				);

				modal.afterClosed().subscribe(() => {
					this.obter();
				});
			});
	}

	public responderSTExterna(selectedModel?: ISolicitacaoTecnicaModel) {
		this.sharedService.numeroOsa
			.pipe(
				filter(numero => numero !== null && numero !== undefined),
				take(1)
			)
			.subscribe(numeroOsa => {
				const dataFimRealizacao = this.sharedService.getDataFimRealizacao();
				const dialogConfig = new MatDialogConfig();
				dialogConfig.id = 'modal-component-responder-solicitacao-tecnica';
				dialogConfig.width = '80%';
				dialogConfig.height = '90%';
				dialogConfig.hasBackdrop = true;
				dialogConfig.disableClose = true;
				dialogConfig.data = {
					responder: true,
					avaliar: false,
					titulo: "Responder",
					element: selectedModel,
					id: selectedModel?.id,
					status: selectedModel?.status,
					visualizar: true,
					tipoTrabalhoId: this.tipotrabalhoId,
					planejamentoId: this.planejamentoId,
					documentoAssociado: this.formatarDocumentoAssociado(numeroOsa),
					tipoTrabalho: this.tipoTrabalho,
					numeroST: selectedModel?.numero,
					dataLimite: dataFimRealizacao
						? new Date(dataFimRealizacao)
						: new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
				};

				const modal = this.matDialog.open(
					OsaExecucaoModalResponderSolicitacaoComponent,
					dialogConfig
				);

				modal.afterClosed().subscribe(() => {
					this.obter();
				});
			});
	}

	public apreciarProrrogacao(element: ISolicitacaoTecnicaModel) {
		const dataFimRealizacao = this.sharedService.getDataFimRealizacao();

		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component";
		dialogConfig.width = "45vw";
		dialogConfig.maxHeight = "85vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			solicitacaoId: element?.id,
			data: element?.tipo == 1 ? element?.prorrogarSolicitacao?.data : new Date(),
			justificativa: element?.prorrogarSolicitacao.justificativa,
			dataLimiteProrrogacao: dataFimRealizacao
				? new Date(dataFimRealizacao)
				: new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
		};
		const modal = this.matDialog.open(
			OsaExecucaoModalAvaliarProrrogacaoComponent,
			dialogConfig
		);
		modal.afterClosed().subscribe((data) => {
			this.obter()
		});
	}

	public habilitarResposta(id: number, prazo: Date) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-component';
		dialogConfig.width = '45vw';
		dialogConfig.maxHeight = '85vh';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
		}
		const modal = this.matDialog.open(ModalJustificativaComponent, dialogConfig);
		modal.afterClosed().subscribe(data => {
			if (data) {
				this.solicitacaoTecnicaService.habilitarRespostaSolicitacao(id, data, prazo)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					}).catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							icon: "error",
							text: err.mensagem.descricao,
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					}).finally(() => {
						this.obter()
					});
			}
		});
	}

	public avaliarResposta(selectedModel?: ISolicitacaoTecnicaModel) {
		this.sharedService.numeroOsa
			.pipe(
				filter(numero => numero !== null && numero !== undefined),
				take(1)
			)
			.subscribe(numeroOsa => {

				// Pega o valor de dataFimRealizacao
				const dataFimRealizacao = this.sharedService.getDataFimRealizacao();

				const dialogConfig = new MatDialogConfig();
				dialogConfig.id = 'modal-component-responder-solicitacao-tecnica';
				dialogConfig.width = '80%';
				dialogConfig.height = '90%';
				dialogConfig.hasBackdrop = true;
				dialogConfig.disableClose = true;
				dialogConfig.data = {
					responder: false,
					avaliar: true,
					titulo: "Avaliar Resposta da",
					element: selectedModel,
					id: selectedModel?.id,
					status: selectedModel?.status,
					visualizar: true,
					tipoTrabalhoId: this.tipotrabalhoId,
					planejamentoId: this.planejamentoId,
					documentoAssociado: this.formatarDocumentoAssociado(numeroOsa),
					tipoTrabalho: this.tipoTrabalho,
					numeroST: selectedModel?.numero,
					dataLimite: dataFimRealizacao
						? new Date(dataFimRealizacao)
						: new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate() + 30)
				};

				const modal = this.matDialog.open(
					OsaExecucaoModalResponderSolicitacaoComponent,
					dialogConfig
				);

				modal.afterClosed().subscribe((data) => {
					if (data) {
					}
					this.obter();
				});

			});
	}

	//#endregion


	formatarTooltipCanc(element: any): string {

		const data = element?.dataHoraCanc
			? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelCanc?.nome || 'Usuário desconhecido';
		const comentario = element?.justificativa || 'Sem comentário';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

}
